export default __webpack_public_path__ + "static/media/Pipe-Hole-.54311734.jpg";